// extracted by mini-css-extract-plugin
module.exports = {"screenPanel":"ScreenPanel_screenPanel__Jxod9"};